// extracted by mini-css-extract-plugin
export default {"Products":"styles_Products__dah+T","ImgProduct":"styles_ImgProduct__tIA8a","ProductName":"styles_ProductName__hyrkY","ProducerName":"styles_ProducerName__DIqOP"};